<template>
    <b-card :class="options.classes" :no-body="options.noBody" :border-variant="options.borderVariant" class="c-card-table">
        <div v-if="caption !== '' && (options.headerStyle === '1' || options.headerStyle === undefined)" slot="header">
            {{caption}}
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <div class="card-header-actions pull-right">
                <slot name="cardTableHeaderActions"></slot>
            </div>
        </div>

        <div class="mb-4" v-if="caption !== '' && options.headerStyle === '2'">
            <h5 class="card-title mb-0">{{caption}}</h5>
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <div class="card-header-actions">
                <slot name="cardTableHeaderActions"></slot>
            </div>
        </div>

        <Table
                :onRowClick="onRowClick"
                :onColumnClick="onColumnClick"
                :onCellClick="onCellClick"
                :onPageClick="onPageClick"
                :options="options"
                :pagination="pagination"
                :rows="rows"
                :columns="columns" />
    </b-card>
</template>
<script>
    import Table from './Table'
    export default {
        extends: Table,
        name: 'CardTable',
        components: {
            Table
        },
        props: {
            caption: {
                type: String,
                default: ''
            },
            subCaption: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: function() {
                    return {
                        headerStyle: '1',
                        borderVariant: '',
                        noBody: false,
                        classes: ''
                    }
                }
            }
        },
        data: function () {
            return {}
        }
    }
</script>

